// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"326929fb","796":"45ee1546"}[chunkId] + ".chunk.js";
};